export default __webpack_public_path__ + "static/media/IHSA.f2cbaafe.png";